class TipoFalta {
  constructor(dados) {
    this.valor = dados.valor;
    this.nome = dados.nome;
  }
}
export default TipoFalta;
